import React, { useState } from 'react';
import './productMainKitSave.css';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import { Button } from '../../../../../UI/Elements';
import { Link } from '../../../../../UI/Elements/Link';

export const ProductMainKitSave = ({ label, subLabel, button, icon }) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <Link slug={button?.slug}>
      <div
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        className='w-full bg-white transform transition duration-500 flex justify-between items-center border border-gray-400 hover:border-black my-4 px-5 py-4'>
        <div className='kit-save-icon w-10 h-10'>
          <Icon
            {...icon}
            size='2xl'
          />
        </div>
        <div className='px-5'>
          <Label
            {...label}
            size='base'
            weight='bold'
          />
          <Label
            {...subLabel}
            size='base'
            weight='light'
          />
        </div>
        <Button
          type={isHover ? 'contained' : 'outlined'}
          color={{ classname: 'primary' }}
          size='lg'
          icon={{
            iconKey: 'HiOutlineChevronRight',
          }}
        />
      </div>
    </Link>
  );
};
